export const BASE_URL = process.env.REACT_APP_API_URL;
export const AMAZON_APPLICATION_ID =
  process.env.REACT_APP_AMAZON_APPLICATION_ID;
export const FE_BASE_URL = process.env.REACT_APP_FE_BASE_URL;
export const REACT_APP_GOOGLE_API_KEY = process.env.REACT_APP_GOOGLE_API_KEY;

//AIzaSyD9xcEWBs-_x0-nLofudKB0sT8UeI51Wi0
